// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrivacyPolicy_wrapper__32wkP","header":"PrivacyPolicy_header__3YZVf","body":"PrivacyPolicy_body__-M9Zf"};